<script>

import ConnectionStatus from "@/components/ConnectionStatus.vue";
import Logo from "@/components/Logo.vue";
import LocalePicker from "@/components/locale/LocalePicker.vue";
import {headerState} from "@/stores/headerStore.js";

export default {
    components: {LocalePicker, Logo, ConnectionStatus},
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
        },
        navigate(path) {
            if (this.$route.path === path) {
                headerState.refreshView();
            }
        }
    },
    mounted() {
        this.$router.beforeEach(() => {
            this.isOpen = false;
            window.scrollTo({top: 0});
        });
    }
}
</script>

<template>
    <div class="menu-header is-hidden-desktop">
        <div class="menu-logo">
            MENU
        </div>
        <a class="navbar-burger" v-bind:class="{'is-active': isOpen}" role="button"
           aria-label="menu" aria-expanded="false" @click="toggleMenu()">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </a>
    </div>
    <aside v-bind:class="{'hidden': !isOpen}" class="menu p-3">
        <div>
            <div class="menu-sidebar-logo">
                <a href="/dashboard"><Logo/></a>
            </div>
            <p class="menu-label">
                <span>{{ $auth.user.first_name ? $t('menu.greeting_named', { name: $auth.user.first_name }) : $t('menu.greeting') }}!</span>
            </p>
            <ul class="menu-list">
                <li>
                    <RouterLink active-class="is-active" to="/dashboard" @click="navigate('/dashboard')">{{ $t('menu.home') }}</RouterLink>
                </li>
                <li>
                    <RouterLink active-class="is-active" to="/szkolenia" @click="navigate('/szkolenia')">
                        {{ $t('trainings.labels.trainings') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin()" active-class="is-active" to="/kategorie-szkolen" @click="navigate('/kategorie-szkolen')">
                        {{ $t('training_categories.labels.training_categories') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin()" active-class="is-active" to="/tagi-szkolen" @click="navigate('/tagi-szkolen')">
                        {{ $t('training_tags.labels.training_tags') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isEmployer() || $auth.isAdmin()" active-class="is-active" to="/pracownicy" @click="navigate('/pracownicy')">
                        {{ $t('employees.labels.employees') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin()" active-class="is-active" to="/pracodawcy" @click="navigate('/pracodawcy')">
                        {{ $t('employers.labels.employers') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isEmployee()" active-class="is-active" to="/transakcje" @click="navigate('/transakcje')">
                        {{ $t('token_transactions.labels.token_transactions') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isEmployer()" active-class="is-active" to="/transakcje-pracownikow" @click="navigate('/transakcje-pracownikow')">
                        {{ $t('token_transactions.labels.employees_transactions') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isEmployer()"  active-class="is-active" to="/transakcje-z-administracja" @click="navigate('/transakcje-z-administracja')">
                        {{ $t('token_transactions.labels.admin_transactions') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isEmployer()" active-class="is-active" to="/zakup-tokenow" @click="navigate('/zakup-tokenow')">
                        {{ $t('token_purchases.labels.tokens_purchase') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isTrainer()" active-class="is-active" to="/historia-szkolen" @click="navigate('/historia-szkolen')">
                        {{ $t('trainings.labels.trainings_history') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin()" active-class="is-active" to="/transakcje-pracownikow" @click="navigate('/transakcje-pracownikow')">
                        {{ $t('token_transactions.labels.employees_transactions') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin()" active-class="is-active" to="/transakcje-pracodawcow" @click="navigate('/transakcje-pracodawcow')">
                        {{ $t('token_transactions.labels.employers_transactions') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin()" active-class="is-active" to="/szkoleniowcy" @click="navigate('/szkoleniowcy')">
                        {{ $t('trainers.labels.trainers') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin()" active-class="is-active" to="/zakupy-tokenow" @click="navigate('/zakupy-tokenow')">
                        {{ $t('token_purchases.labels.tokens_purchases') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin()" active-class="is-active" to="/zarzadzanie-wyplatami" @click="navigate('/zarzadzanie-wyplatami')">
                        {{ $t('withdrawal_requests.labels.withdrawals_management') }}
                    </RouterLink>
                    <RouterLink v-if="$auth.isAdmin() || $auth.isEmployer()" active-class="is-active" to="/faktury" @click="navigate('/faktury')">
                        {{ $t('invoices.labels.invoices') }}
                    </RouterLink>
                </li>
            </ul>

            <p class="menu-label">{{ $t('menu.account_section_label') }}</p>
            <ul class="menu-list">
                <li>
                    <RouterLink active-class="is-active" to="/moje-dane" @click="navigate('/moje-dane')">{{ $t('users.labels.my_profile') }}</RouterLink>
                </li>
                <li>
                    <RouterLink active-class="is-active" to="/zmiana-hasla" @click="navigate('/zmiana-hasla')">{{ $t('auth.labels.password_change') }}</RouterLink>
                </li>
                <li>
                    <a @click="$auth.logout"> {{ $t('auth.labels.logout') }} </a>
                </li>
            </ul>
        </div>
        <div class="sidebar-light-switch-wrapper">
            <div class="menu-tools">
                <light-switch/>
                <LocalePicker/>
            </div>
            <ConnectionStatus />
        </div>
    </aside>
    <div class="sidebar-bg is-hidden-desktop" v-if="isOpen"></div>

</template>

<style scoped lang="scss">
@use "bulma/sass/utilities/mixins";

$sidebar-width: 250px;

.menu-header {
    position: fixed;
    top: 0;
    height: 50px;
    width: 100%;
    background-color: var(--bulma-body-background-color);
    z-index: 20;

    .menu-logo {
        display: inline-block;
        width: 100%;
        text-align: center;
        height: 100%;
        line-height: 50px;
    }

    .navbar-burger {
        position: absolute;
        top: 0;
        right: 0;
        height: 50px;
        width: 50px;
    }
}

aside.menu {
    position: fixed;
    left: 0;
    z-index: 20;
    background-color: var(--bulma-body-background-color);
    transition: left 0.3s ease-in-out;
    max-width: $sidebar-width;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 15px;

    @include mixins.touch() {
        top: 50px;
        height: calc(100% - 50px);

        &.hidden {
            left: -100%;
        }
    }
}

.sidebar-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(2px);
}
</style>
